
export class BillingInfo{
   currency=""
     week= 0.0
     month= 0.0
     year= 0.0
     alpha2=""
     mobile_money_yes=0
     server_billing_chart_id=0

}
